import { differenceInSeconds } from "date-fns";
import { MAX_DURATION_SECONDS } from "../consts";

/**
 * Calculates the duration in seconds between two date/time values.
 * The result is the actual calendar difference, capped at MAX_DURATION_SECONDS (999 hours).
 *
 * @param from - The start date/time
 * @param to - The end date/time
 * @returns The duration in seconds, capped at MAX_DURATION_SECONDS (999:00:00)
 */
export const calculateDuration = (from: Date, to: Date): number => {
  const durationSeconds = Math.max(0, differenceInSeconds(to, from));
  return Math.min(MAX_DURATION_SECONDS, durationSeconds);
};
